import ReducerUtils from "../../../utils/ReducerUtils"
import Actions from "../../../model/constant/actions"

const Keywords = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_KEYWORDS_STATISTICS] : (_,action)=>action.status
})

export default Keywords
